import * as React from "react";
import { ChangeEvent } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl } from "@material-ui/core";

export interface BranchData {
  id: number;
  name: string;
  location: {
    lat: number;
    lng: number;
  };
  street1: string;
  street2: string;
  observation: string;
  number: number;
  company: {
    id: number;
    name: string;
    photo: string;
    admin: string;
    priceDelivery: number;
  };
}

interface BranchSelectorState {
  branchList: BranchData[];
  selectedIndex: number;
}

export interface BranchSelectorProps {
  branchList: BranchData[] | undefined;
  selected?: number;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => any;
  style?: React.CSSProperties;
}

export class BranchSelector extends React.Component<
  BranchSelectorProps,
  BranchSelectorState
> {
  constructor(props: BranchSelectorProps) {
    super(props);

    this.state = {
      selectedIndex: 0,
      branchList: [],
    };
    this.handleChangeEvent = this.handleChangeEvent.bind(this);
  }

  handleChangeEvent(e: ChangeEvent<HTMLSelectElement>) {
    this.props.onChange(e);
    this.setState({
      selectedIndex: +e.target.value,
    });
  }

  render() {
    const indexBranch = this.props.selected
      ? this.props.selected
      : this.state.selectedIndex;
    return (
      <FormControl style={this.props.style}>
        {console.log("branch list", this.props.branchList)}
        <Select
          value={indexBranch}
          inputProps={{
            name: "branch-selector",
            id: "branchSelector",
          }}
          onChange={this.handleChangeEvent}
        >
          {this.props.branchList
            ? this.props.branchList.map((branch, index) => (
                <MenuItem key={index} value={index}>
                  {branch.company.name} / {branch.name}{" "}
                </MenuItem>
              ))
            : ""}
        </Select>
      </FormControl>
    );
  }
}

export default BranchSelector;



// WEBPACK FOOTER //
// ./src/components/BranchSelector.tsx